<script lang="ts">
	export let href: string;

	function isAbsoluteUrl(url: string): boolean {
		return /^(http|https):\/\//.test(url);
	}

	let target = '';

	$: {
		if (isAbsoluteUrl(href) && !href.startsWith('https://last1372.com')) {
			target = '_blank';
		} else {
			target = '';
		}
	}
</script>

<a {href} {target} rel={target ? 'noopener noreferrer' : undefined}>
	<slot />
</a>
